import PropTypes from 'prop-types';
import { Box, Text } from '@rsos/components/capstone/base';
import { EMERGENCY_CALLS, NON_CALLS } from '@rsos/constants/incidentTypes';
import { getTheme } from '@rsos/theme/themes';
import getCallStatusName from '@rsos/utils/getCallStatusName';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import { convertUnixTimestamp } from '@rsos/utils/timeHelpers';
import { CallStatus, CallStatusTag } from './InfoWindow.styles';

/**
 * Wrapper component for Google Maps info window content.
 * This is an uncontrolled component, no access to the redux store or themes,
 * props should be passed down.
 * @param {string} type - content type for EMERGENCY CALLS or ALERTS
 * @param {object} data - content data based on content type
 * @param {object} callQueue - callQueue or filteredCalls
 * @returns Google Maps info window content
 */
const InfoWindowContent = ({ type, data, callStatus, themeName = 'light' }) => {
  if (type === EMERGENCY_CALLS) {
    const theme = getTheme(themeName);
    const { caller_id, call_start_time } = data;
    const formattedCallerID = formatInternationalPhoneNumberHuman(caller_id);

    const callStatusDisplayName = getCallStatusName(callStatus);

    return (
      <Box>
        <Text marginBottom={'5px'}>{formattedCallerID}</Text>
        <Text marginBottom={'5px'}>
          {convertUnixTimestamp(Number(call_start_time), true)}
        </Text>

        {callStatusDisplayName && (
          <CallStatusTag status={callStatus} isCallPopup={true} theme={theme}>
            <CallStatus
              data-name="call-status"
              status={callStatus}
              theme={theme}
            >
              {callStatusDisplayName}
            </CallStatus>
          </CallStatusTag>
        )}
      </Box>
    );
  }
  if (type === NON_CALLS) {
    const theme = getTheme(themeName);
    const { status, trip_data } = data.body || {};
    const latestStatus = status?.[status.length - 1];

    return (
      <Box flexGrow>
        {latestStatus ? (
          <>
            <Text marginBottom={'5px'}>{latestStatus.update}</Text>
            <Text marginBottom={'5px'}>
              {new Date(latestStatus.timestamp).toLocaleTimeString()}
            </Text>
          </>
        ) : (
          <Text marginBottom={'5px'}>Pending</Text>
        )}

        {trip_data && (
          <CallStatus data-name="non-call-status" theme={theme}>
            {trip_data.trip_reason}
          </CallStatus>
        )}
      </Box>
    );
  }
  return null;
};

InfoWindowContent.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.shape({}).isRequired,
  isAllView: PropTypes.bool,
};

export default InfoWindowContent;
